import { useCallback, useRef, useState } from 'react';

import {
  Avatar,
  AvatarGroup,
  Box,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { stringAvatar } from '../../../utils/avatarGenerator';
import { InfoCard } from '../../../components/InfoCard';
import { Board } from '../../../services/requests';

import {
  Card,
  Container,
  Div,
  MembersNumber,
  Page,
  SectionMembers,
  Title,
} from './styles';
import useAuthStore from '../../../store/auth';

dayjs().format();

interface BoardProps {
  boardsActives: Board[] | undefined;
  loading: boolean;
  setBoardArchives: any;
}

export const CardBoardActives = ({
  boardsActives,
  loading,
  setBoardArchives,
}: BoardProps) => {
  const navigate = useNavigate();

  const user = useAuthStore(state => state.user);

  const [boardStatus, setBoardStatus] = useState<Partial<Board>>();

  const handleError = useCallback(() => {
    toast.dismiss();
    toast.error('Você não tem autorização para acessar este Board');
  }, []);

  if (loading) {
    <Container>
      <CircularProgress />
    </Container>;
  }

  return (
    <Div>
      {loading ? (
        <Page
          display="flex"
          paddingTop="250px"
          justifyContent="center"
          width="100%"
        >
          <CircularProgress />
        </Page>
      ) : boardsActives && boardsActives?.length > 0 ? (
        <Container className="Container">
          {boardsActives?.map(b => (
            <Card
              status={b.status}
              key={b.id}
              onClick={
                b?.members_ids?.includes(user?.id as string) ||
                user?.profile === 'UN1' ||
                user?.profile === 'UN2'
                  ? () => navigate(`board-details/${b.id}`)
                  : () => handleError()
              }
              sx={{ borderColor: b.color }}
              disabled={
                !b?.members_ids?.includes(user?.id as string) &&
                (user?.profile === 'UN3' || user?.profile === 'UN4')
              }
            >
              <Box display="flex" width="100%">
                <Tooltip title={b.title} arrow>
                  <Title>{b.title}</Title>
                </Tooltip>
              </Box>
              <SectionMembers>
                <MembersNumber>
                  {b?.members && b?.members.length}{' '}
                  {b?.members && b?.members.length > 1
                    ? 'PARTICIPANTES'
                    : 'PARTICIPANTE'}
                </MembersNumber>
                <AvatarGroup max={5}>
                  {b?.members?.map(e => (
                    <Tooltip title={e.name} arrow>
                      {e?.avatar_url ? (
                        <Avatar sx={{ width: '42px' }}>
                          <img
                            src={e?.avatar_url as string}
                            alt="Foto de perfil"
                            style={{ width: '100%' }}
                          />
                        </Avatar>
                      ) : (
                        <Avatar
                          {...stringAvatar(e.name!)}
                          sx={{ width: '42px' }}
                        />
                      )}
                    </Tooltip>
                  ))}
                </AvatarGroup>
              </SectionMembers>
            </Card>
          ))}
        </Container>
      ) : (
        <Page
          display="flex"
          paddingTop="250px"
          justifyContent="center"
          width="100%"
        >
          <InfoCard
            title="No momento você não possui boards criados."
            type="info"
          />
        </Page>
      )}
    </Div>
  );
};
